import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { TieService } from '../../../../_core/services/tie.service';
import { ToastService } from '../../../../_core/services/toast.service';
import { SelectUserComponent } from '../../../../_shared/components/select-user/select-user.component';
import { Tie } from '../../../../_shared/models/tie.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-invite-team-owner',
    templateUrl: './invite-team-owner.component.html',
    styleUrls: ['./invite-team-owner.component.scss'],
    standalone: true,
    imports: [
        IonicModule,
        TranslateModule
    ]
})
export class InviteTeamOwnerComponent implements OnDestroy {
    @Input() tie: Tie;
    @Input() sideNumber: number;
    @Output() updateTie = new EventEmitter<Tie>();

    isLoading = false;
    private destroyed$: Subject<void> = new Subject();

    constructor(
        private tieService: TieService,
        private modalController: ModalController,
        private toast: ToastService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    async invite() {
        const user = await this.getUser();

        if (!user) return;

        const phone = user.country_code + user.phone;

        this.isLoading = true;
        this.tieService
            .addTeamOwner(this.tie._id, phone, this.sideNumber)
            .pipe(
                takeUntil(this.destroyed$),
                finalize(() => this.isLoading = false)
            )
            .subscribe(
                res => {
                    this.tie = res.data;
                    this.cdr.detectChanges();
                    this.updateTie.emit(this.tie);
                    this.toast.presentToast(res.message);
                },
                err => {
                    //console.log(err);
                }
            );
    }

    private async getUser() {
        const modal = await this.modalController
            .create({
                component: SelectUserComponent
            });

        await modal.present();
        const { data } = await modal.onDidDismiss();
        return data;

    }

    showButton() {        
        return this.tie.sides[this.sideNumber - 1].owners?.length > 0 ? false : true;
    }

}
